import React, { useState } from "react";
import { ChevronsUpDown, Eye } from "lucide-react";
import { countSegments, usDate, usPhoneFormat} from "../../helpers";
import MessageViewModal from "../Modal/MessageViewModal";
import Skeleton from "react-loading-skeleton";

const styles = {
  display: "flex",
  alignItems: "center",
  gap: "5px",
  cursor: "pointer",
};

export default function OutgoingFidelisMessageDataTable(props) {
  const {
    tableData = [],
    setDataLoading = () => {},
    reloadData = () => {},
    reloadDataFilter = {},
    dataLoading = false,
    messageTemplate = []
  } = props;

  const LimitText = ({ text, limit }) => {
    if (text.length <= limit) {
      return text;
    } else {
      const limitText = text.substring(0, limit) + "...";
      return limitText;
    }
  };

  const [orderBy, setOrderBy] = useState();
  const [activeModal, setActiveModal] = useState(false);
  const [detailsData, setDetailsData] = useState(null);
  const [previousScrollPosition, setPreviousScrollPosition] = useState(0);

  const handleOrderChange = (name, type = "asc") => {
    name = name.toString();
    setOrderBy(name);
    if (reloadDataFilter.order_by && reloadDataFilter.order_by[0] === name) {
      if (reloadDataFilter.order_by[1] === "asc") {
        type = "desc";
      }
    }
    const orderFilter = { order_by: [name, type.toString()] };
    const filter_merge = { ...reloadDataFilter, ...orderFilter };
    reloadData(filter_merge);
    setDataLoading(true);
  };

  const handleNoteView = (details) => {
    setDetailsData(details);
    setActiveModal(!activeModal);
    setPreviousScrollPosition(window.scrollY);
    window.scrollTo(0, 0);
  }
  
  return (
    <>
      <div className="docpro_table_responsive" style={{ minHeight: "250px" }}>
        <table className="docpro_mb_0">
          <thead>
            <tr>
              <th
                onClick={() => {
                  handleOrderChange("phone");
                }}
                className={
                  orderBy === "phone" ? "docpro_accent_color" : ""
                }
              >
                <div style={styles}>
                  Phone <ChevronsUpDown size={"12"} />
                </div>
              </th>
              <th>Category</th>
              <th>Message Body</th>
              <th
                onClick={() => {
                  handleOrderChange("status");
                }}
                className={orderBy === "status" ? "docpro_accent_color" : ""}
              >
                <div style={styles}>
                  Status <ChevronsUpDown size={"12"} />
                </div>
              </th>
              <th>Segment</th>
              <th
                onClick={() => {
                  handleOrderChange("created_at");
                }}
                className={orderBy === "created_at" ? "docpro_accent_color" : ""}
              >
                <div style={styles}>
                  Create Time <ChevronsUpDown size={"12"} />
                </div>
              </th>
              <th className="docpro_text_center">Action</th>
            </tr>
          </thead>
          <tbody>
            {!dataLoading ? (
              tableData.length > 0 ? (
                tableData?.map((item, index) => (
                  <tr key={index} className={`row_${item.id}`}>
                    <td>{usPhoneFormat(item?.phone)}</td>
                    <td>
                      {item?.template_id && (
                        <LimitText text={messageTemplate.find(t => t.id === item.template_id)?.title || ""} limit={25} />
                      )}
                    </td>
                    <td>
                      <LimitText text={item.message_body} limit={30} />
                    </td>
                    <td>
                      {(() => {
                        const statusClassMap = {
                          delivered: "docpro_badge_success",
                          initialized: "docpro_badge_info",
                          failed: "docpro_badge_danger",
                          queued: "docpro_badge_info",
                          scheduled: "docpro_badge_schedule",
                          insufficient_credits: "docpro_badge_pending",
                          invalid_phone: "docpro_badge_danger",
                        };
                        const rawStatus = item.status || "";
                        const formattedStatus = rawStatus.charAt(0).toUpperCase() + rawStatus.slice(1).replace(/_/g, " ");
                        const badgeClass = statusClassMap[rawStatus] || "docpro_badge_olive";

                        return (
                          <span className={`docpro_badge ${badgeClass}`}>{formattedStatus}</span>
                        );
                      })()}
                    </td>
                    <td>{countSegments(item.message_body)}</td>
                    <td>{usDate(item?.created_at, true, false)}</td>
                    <td>
                      <div className="docpro_icon_btns">
                        <button
                          className="docpro_icon_btn"
                          onClick={() => handleNoteView(item)}
                        >
                          <Eye width={20} height={20} />
                          <span className="docpro_tip">View Message</span>
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td className="no_data docpro_p_0" style={{ height: "250px" }} colSpan="7">
                    No data available
                  </td>
                </tr>
              )
            ) : (
              Array.from({ length: 8 }).map((_, index) => (
                <tr key={index} style={{ height: '50px' }}>
                  <td> <Skeleton width="6rem" borderRadius="8px"></Skeleton> </td>
                  <td> <Skeleton width={`${5 + (index % 2.5)}rem`} borderRadius="8px"></Skeleton> </td>
                  <td> <Skeleton width={`${3 + (index % 3)}rem`} borderRadius="8px"></Skeleton> </td>
                  <td> <Skeleton width={`${4 + (index % 2)}rem`} borderRadius="8px"></Skeleton> </td>
                  <td> <Skeleton width={`${2 + (index % 1.5)}rem`} borderRadius="8px"></Skeleton> </td>
                  <td> <Skeleton width={`${4 + (index % 1.2)}rem`} borderRadius="8px"></Skeleton> </td>
                  <td className="text-center"> <Skeleton width="3rem" borderRadius="8px"></Skeleton> </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {activeModal && (
        <MessageViewModal
          activeModal={activeModal}
          setActiveModal={setActiveModal}
          message_body={detailsData?.message_body}
          segment={detailsData?.segment}
          previousScrollPosition={previousScrollPosition}
        />
      )}
    </>
  );
}
